import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// ============================================================================
// Beszerzés — a vásárolt (nem gyártott) alkatrészek utántöltési feladatai.
// A Gyártás a nyomtatott tételeket viszi; ami vásárolt, arra itt keletkezik
// feladat, ugyanazzal a cél = minimum + foglalás logikával.
// ============================================================================

export interface ProcurementTask {
  sku: string;
  name: string;
  /** komponens kép fájlnév (components/images/:file) vagy null */
  imageFile: string | null;
  /** beszerzési ár Ft/db */
  purchasePrice: number | null;
  /** aktuális fizikai készlet */
  stock: number;
  /** készletminimum */
  minStock: number;
  /** aktív rendelések által lefoglalt db */
  reserved: number;
  /** cél: minStock + reserved */
  target: number;
  /** beszerzendő: max(0, target − stock) */
  need: number;
  /** a beszerzendő mennyiség becsült költsége Ft-ban */
  estimatedCost: number | null;
  /** elfogyott és rendelés vár rá */
  urgent: boolean;
  /** elfogyott */
  out: boolean;
}

export interface ProcurementQueue {
  tasks: ProcurementTask[];
  totalPieces: number;
  /** a teljes lista becsült beszerzési költsége Ft-ban */
  totalCost: number;
  /** hány tételnél hiányzik a beszerzési ár */
  missingPriceCount: number;
}

export interface ReceiveStockRequest {
  sku: string;
  /** megérkezett darabszám — a készletre kerül */
  quantity: number;
  /** opcionális megjegyzés (pl. szállítólevél száma) */
  note?: string;
}

export interface ReceiveStockResponse {
  sku: string;
  newStock: number;
}

@Injectable({ providedIn: 'root' })
export class ProcurementService {

  constructor(private http: HttpClient) {}

  /** GET procurement/queue — beszerzési feladatlista */
  getQueue(): Observable<ProcurementQueue> {
    return this.http.get<ProcurementQueue>('procurement/queue');
  }

  /** POST procurement/receive — beérkezett áru bevételezése (készletnövelés) */
  receiveStock(request: ReceiveStockRequest): Observable<ReceiveStockResponse> {
    return this.http.post<ReceiveStockResponse>('procurement/receive', request);
  }
}
